<div class="wrapper">
    <router-outlet></router-outlet>
    <ng-http-loader [minDuration]="200" [spinner]="spinkit.skThreeBounce"
                    [backgroundColor]="'#7093FF'"></ng-http-loader>
</div>
